import React from 'react'

const Project_man = () => {
    return (
        <div className='container'>
            <h1 itemprop="headline">IT Career Roadmap: IT project manager</h1>
            <section class="deck viewability">
			<h3 itemprop="description">Behind every successful IT project is a great project manager. Here's what a career as a PM looks like and what it takes to get there.</h3>
		</section>
        <br /> <br /> <br />  <br />
        <hr />
            <div id="drr-container" class="cat " itemprop="articleBody">
<p>Behind every IT project are the unsung heroes of the technology industry: project managers. PMs are tasked with
    making sure projects come in on-time, on or under budget and with high-quality standards. But what does it take
    to become an IT project manager?
</p>
<p>"This is one of the great part about this career: There's no specific 'right' background as far as education goes
    that you need to be a good project manager. We've seen PMs come from all sorts of diverse study areas: English
    majors, general liberal arts, computer science and engineering, law, business," says P.K. Agarwal, CEO and
    regional dean for <a href="http://www.northeastern.edu/siliconvalley/"
        title="Northeastern University - Silicon Valley" target="_blank">Northeastern University - Silicon
        Valley</a>.
</p>
<figure class="large " itemprop="associatedMedia" itemscope="" itemtype="http://schema.org/ImageObject"
    itemid="http://images.techhive.com/images/article/2016/11/career-roadmap-pm_chart-100693922-large.jpg">
    <img height="456" width="700" alt="career roadmap pm chart"
        data-original="https://images.techhive.com/images/article/2016/11/career-roadmap-pm_chart-100693922-large.jpg"
        class="lazy" loading="lazy"
        src="https://images.techhive.com/images/article/2016/11/career-roadmap-pm_chart-100693922-large.jpg"/>
    <small class="credit" itemprop="copyrightHolder"><a href="http://thinkstockphotos.com" target="_blank"
            rel="nofollow">Thinkstock</a> </small>
</figure>
<h3>Accidental project managers
</h3>
<p>Many times, project management pros don't even need a formal degree; a <a
        href="http://www.tomsitpro.com/articles/project-management-certifications,2-670.html"
        title="project management certification" target="_blank">project management certification</a>, like the
    Project Management Professional (PMP) certification from the <a href="https://www.pmi.org/certifications"
        title="Project Management Institute (PMI)" target="_blank">Project Management Institute (PMI)</a>, is enough
    to validate expertise and experience.
</p>
<p>These "accidental project managers" are those who've evolved into this role because of their excellent
    communication, organizational and administrative skills as well as management ability, even though they might
    not have a degree, Agarwal says.
</p>
<p>"It's more about the soft skills, organizational and administrative skills and ability to communicate and
    influence effectively, as well as attention to detail," Agarwal says.
</p>
<p>Though she's recently moved into sales consulting positions and is currently a regional sales consulting manager
    for project portfolio management software company <a href="https://www.planview.com/" title="Planview"
        target="_blank">Planview</a>, Kristyn Medeiros spent the majority of her career as an IT project manager for
    Johnson &amp; Johnson and Sandia National Laboratories, among others.
</p>
<p><strong>[ Related story: <a
            href="http://www.cio.com/article/3119685/it-skills-training/career-roadmap-making-a-career-in-devops.html"
            title="Career Roadmap: Making a career in DevOps" target="_blank">Career Roadmap: Making a career in
            DevOps</a> ]</strong></p>
<h3>A different path
</h3>
<p>With a computer science degree and a minor in special education, Medeiros thought she'd end up working to
    leverage technology to help improve the special education landscape. Instead, she found herself motivated and
    fulfilled as a project manager, and has continued in that career path, she says. She also found she liked the
    communications and influencer aspects of a project management role.
</p>
<p>"The thing that really clinched this for me as a career path was I joined a Toastmasters chapter to help me with
    my public speaking. Day-to-day in project management, you're really in the weeds, so to speak, focused on the
    details and the minutia of deadlines, which I liked, but I also wanted to be better at my communication skills
    and be able to influence others on my teams in IT even though I wasn't directly supervising them," Medeiros
    says.
</p>
<p>That's an aspect of a successful project management career that's often overlooked, Medeiros says. Because PMs
    must manage all aspects of an IT project including budget, resources, time and staffing. Excellent management
    and multitasking skills are critical.
</p>
<p>There's also a need to be able to assertively advocate for the resources and staffing needs of your projects, and
    to understand and influence business drivers and ensure strategic alignment with overall business goals, she
    says.
</p>
<p>"To everyone else, it might feel like it's 'just' one tiny project out of maybe 10 that you're working on, but
    you have to understand how that aligns with the rest of the organization's plans so you can fight for everything
    you need," she says.
</p>
<p><strong>[ Related story: <a
            href="http://www.cio.com/article/3139873/project-management/5-secrets-to-creating-the-best-project-management-resume.html"
            title="5 secrets to creating the best project management resume" target="_blank">5 secrets to creating
            the best project management resume</a> ]</strong></p>
<h3>Driving demand
</h3>
<p>Right now, IT project managers are in huge demand as organizations struggle to handle digital transformation and
    the breakneck pace of innovation with fewer heads and scarce resources, says Laurie Emerson, vice president of
    consulting for Planview.
</p>
<p>"Every company today, even those that aren't specifically IT companies, has initiatives to integrate IT into
    every aspect of the business. And that's why IT project managers are so critical, because they have both the
    technical savvy to understand the business drivers along with the soft skills to persuade stakeholders, get
    executive buy in and execute on these plans," Emerson says.
</p>
<p>Many organizations are using part-time, contract or consultative project management professionals to easily scale
    up or down to meet their project management needs more efficiently, says Shalom Berkowitz, recruiting junior
    team lead, IT recruiting and staffing firm <a href="http://www.mondo.com/" title="Mondo website"
        target="_blank">Mondo</a>.
</p>
<p>"These are the requests we get the most. Everyone's constantly integrating, updating and modifying software, so
    the demand for IT project management never really goes away," he says.
</p>
<p>Most companies are looking for experienced project managers who can plan, execute and close projects; a proven
    history of defining, planning, executing IT projects is a must, as well as soft skills like communication,
    negotiation, teamwork, management and organizational acumen also are necessary, he says, along with hard
    technology skills.
</p>
<p>"The hard skills, though, can vary significantly by project. For example, let's take an SAP implementation.
    Someone hiring a project manager for this project would look for a candidate with several years as a business
    analyst or someone who's had years of experience in general project management, and then look for specialized
    knowledge and experience with SAP. Maybe they've done one or two SAP implementations before, successfully,"
    Berkowitz says.
</p>
<p><strong>[ Related story: <a
            href="http://www.cio.com/article/3057574/careers-staffing/it-career-roadmap-data-scientist.html"
            title="IT career roadmap: How to become a data scientist" target="_blank">IT career roadmap: How to
            become a data scientist</a> ]</strong></p>
<h3>Icing on the cake
</h3>
<p>Finally, Mondo's clients strongly prefer project management candidates with a PMP certification, or with some
    kind of credential related to the agile software development methodology to make sure they know the ins and outs
    of what the project will entail, Berkowitz says.
</p>
<p>"This is highly, highly recommended so companies know their PMs already are educated in these areas, no matter
    what the project. It's a nice icing on the cake to companies to get project managers with these certifications,"
    he says.
</p>
<p>One of the best things about a career in project management, Medeiros says, is the opportunities for career
    mobility. Many PMs can choose to move to a business analyst role, or into consulting or analytics, or even to a
    sales consulting and demo role, like Medeiros's current position.
</p>
<p>"There's such a great opportunity to take these skills beyond just the project management role. You're not just
    proficient in IT, but you get insight and experience into every part of the business. You're definitely not
    limited in terms of where your career can take you," she says.
</p>


<div class="end-note">

</div>


</div>
        </div>
    )
}

export default Project_man
